module.exports = __webpack_public_path__ + "static/media/evaluation.5889a79d.svg";